/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Types for SettingsAutoReports table
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

export enum EScheduleColumns {
    DESCRIPTION = 'description',
    ORDER_ATTR_TYPE = 'orderAttrType',
    PERIOD_TYPE = 'periodType',
    REMOVE = 'remove',
    REPORT_FORMAT = 'reportFormat',
    REPORT = 'report',
    START_TIME = 'startTime'
};

interface IField {
    id: number;
    def: string;
};

export interface ITableScheduleColumns {
    compressionType: number;
    cppoId: number;
    dayOfPeriodName: string;
    description: string;
    id: string;
    orderAttrType: IField;
    periodType: IField;
    report: IField;
    reportFormat: IField;
    startTime: string;
    susrId: number;
    remove: string;
};
